import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Clears `body.style.pointerEvents = 'none'` after every navigation. Radix overlays (Sheet,
 * Dialog, DropdownMenu) write that lock to body while open; their cleanup is gated by Presence
 * exit animations, so if a parent unmounts the overlay before the animation finishes the lock
 * leaks. Scrubbing on every nav event catches the leak regardless of which shell or layout was
 * responsible for it.
 */
export function RadixBodyLockScrub(): null {
  const location = useLocation();
  useEffect(() => {
    if (document.body.style.pointerEvents === 'none') {
      document.body.style.pointerEvents = '';
    }
  }, [location.key]);
  return null;
}
